const ACCESS_KEY = 'school_pc_access_token';
const REFRESH_KEY = 'school_pc_refresh_token';
/** 本地认为应发起无感刷新的时间点（ms），早于服务端 access 实际过期 */
const ACCESS_PROACTIVE_REFRESH_AT_KEY = 'school_pc_access_proactive_refresh_at';
/** 旧版单 token，首次读取时迁移到 access */
const LEGACY_TOKEN_KEY = 'school_pc_token';

/** 比接口 expires_in 提前的秒数，用于本地判定何时刷新 */
export const ACCESS_TOKEN_REFRESH_MARGIN_SEC = 120;

export function getAccessToken() {
  let t = localStorage.getItem(ACCESS_KEY);
  if (!t) {
    const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
    if (legacy) {
      t = legacy;
      localStorage.setItem(ACCESS_KEY, legacy);
      localStorage.removeItem(LEGACY_TOKEN_KEY);
    }
  }
  return t || '';
}

export function setAccessToken(token) {
  if (token) localStorage.setItem(ACCESS_KEY, token);
  else localStorage.removeItem(ACCESS_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY) || '';
}

export function setRefreshToken(token) {
  if (token) localStorage.setItem(REFRESH_KEY, token);
  else localStorage.removeItem(REFRESH_KEY);
}

export function getToken() {
  return getAccessToken();
}

export function setToken(token) {
  setAccessToken(token);
}

export function getAccessProactiveRefreshAt() {
  const raw = localStorage.getItem(ACCESS_PROACTIVE_REFRESH_AT_KEY);
  if (!raw) return 0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

/**
 * 根据服务端 expires_in（秒）写入「应刷新」的绝对时间：now + (expires_in - margin)
 * @param {number|undefined} expiresInSec
 */
export function setAccessProactiveRefreshAtFromExpiresIn(expiresInSec) {
  const base = Number(expiresInSec);
  const ei = Number.isFinite(base) && base > 0 ? base : 7200;
  const activeSec = Math.max(60, ei - ACCESS_TOKEN_REFRESH_MARGIN_SEC);
  localStorage.setItem(ACCESS_PROACTIVE_REFRESH_AT_KEY, String(Date.now() + activeSec * 1000));
}

export function clearAccessProactiveRefreshAt() {
  localStorage.removeItem(ACCESS_PROACTIVE_REFRESH_AT_KEY);
}

export function removeToken() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
  clearAccessProactiveRefreshAt();
}
